import axios from "axios";
import {InquireCompanionPlanRequest} from "../models/inquire-companion-plan-request";
import {CreateOrderRequest} from "../models/create-order-request";
import {
  AutoCompleteResponse,
  CapturedAddress,
  CreateWatchOrderResponse,
  InquireAddressFieldsResponse,
} from "../states/plan-state/plan-atoms";
import {CreateSwapOrderRequest} from "../models/create-swap-order-request";
import {InquireCompanionFlowResponse} from "../models/inquire-companion-flow-response";
import {GenericResponse} from "../models/generic-response";

const api = axios.create({
  baseURL: localStorage.getItem('api') || process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["collation"] = localStorage.getItem("lang");
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const inquireCompanionPlans = async (
) => {
  const response = await api.get("/watch/pair/inquireCompanionPlans", {
    data: {},
    headers: {
      'content-type': 'application/json',
    }
  });
  return response.data;
};

export const createWatchOrder = async (postData: CreateOrderRequest) => {
  const response = await api.post("/watch/pair/createWatchOrder", postData);
  return response.data;
};

export const inquireServiceAndEmergencyAddress = async (postData: {accountId: number}) => {
  const response = await api.post("/watch/pair/inquireServiceAndEmergencyAddress", postData);
  return response.data;
};

export const inquireWatchMsisdn = async (postData: {serviceAddress: CapturedAddress, customerId: number, customerOrderId: number, accountId?: number}) => {
  const response = await api.post("/watch/pair/inquireWatchMsisdn", postData);
  return response.data;
};

export const createPairingDeviceOrder = async (postData: CreateOrderRequest) => {
  const response = await api.post("/watch/pair/createPairingDeviceOrder", postData);
  return response.data;
};

export const submitWatchOrder = async (postData: CreateWatchOrderResponse):Promise<GenericResponse<any>> => {
  const response = await api.post("/watch/pair/submitWatchOrder", postData);
  return response.data;
};

export const submitSwapOrder = async (postData: CreateWatchOrderResponse) => {
  const response = await api.post("/watch/pair/submitSwapOrder", postData);
  return response.data;
};

export const addressAutoComplete = async (postData: {searchString: string}): Promise<AutoCompleteResponse[]> => {
  const response = await api.post("/marvel/address/autoComplete", postData);
  return response.data;
};
export const inquireAddressFields = async (): Promise<InquireAddressFieldsResponse> => {
  const response = await api.get("/marvel/portability/inquireAddressFields", {
    data: {},
    headers: {
      'content-type': 'application/json',
    }
  });
  return response.data;
};


export const getAddress = async (addressId: string): Promise<CapturedAddress> => {
  const response = await api.get("/marvel/address", {
    params: {
      postAddressId: addressId,
    },
    data: {},
    headers: {
      'content-type': 'application/json',
    }
  });
  return response.data;
};

export const createSwapOrder = async (postData: CreateSwapOrderRequest) => {
  const response = await api.post("/watch/pair/createSwapOrder", postData);
  return response.data;
};

export const inquireCompanionPairFlow = async (
  postData: InquireCompanionPlanRequest,
): Promise<InquireCompanionFlowResponse> => {
  const response = await api.post(
    "/watch/pair/inquireCompanionPairFlow",
    postData,
  );
  return response.data;
};




